import { defineNotificationCategory, extractRelativeActionUrl } from './types';

export const feedbackDescriptor = defineNotificationCategory('feedback', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: (data) => [data.feedbackFormName, 'Feedback'],
});

export const ideaCommentsDescriptor = defineNotificationCategory('idea_comments', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Comments'],
});

export const commentMentionDescriptor = defineNotificationCategory('comment_mention', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Mention'],
});

export const staleIdeasDescriptor = defineNotificationCategory('stale_ideas', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Planning'],
});
